/* global axios */
import ApiClient from './ApiClient';

class SpellCheckerAPI extends ApiClient {
  constructor() {
    super('spell_checker', { accountScoped: true });
  }

  check(text, language = null) {
    const params = { text };
    if (language) {
      params.language = language;
    }
    return axios.post(`${this.url}/check`, params);
  }
}

export default new SpellCheckerAPI();
